<template>
  <div class="tonglan">
    <div class="xwlb">
      <div id="lbl" class="lbl">
        <div class="dbti" id="conent">
          <h1 style="text-align: center; height: 40px; padding-top: 25px">
            交易规则
          </h1>
          <h2 style="height: 30px"></h2>
          <p id="con"></p>

          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">一 &nbsp;总则</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">第一条：药聚多平台</span
            ><span style="font-size: 14px">(http://www.yaojuduo.com/</span
            ><span style="font-size: 14px"
              >）是北京汉宁恒丰医药科技有限公司运营的第三方医药电子交易服务平台。为保障药聚多平台会员的合法权益，维护经营秩序，本着公开、公平、公正、诚实守信的原则，根据《中华人民共和国药品管理法》、《医疗器械监督管理条例》《中华人民共和国合同法》、《药品经营质量管理规范》、《药品流通监督管理办法》、《互联网药品信息服务管理办法》及《互联网药品交易服务审批暂行规定》、等有关法律法规和政策，制定本规则。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二条：药聚多平台有权变更本规则或制定相关实施细则并在网站上予以公告。若会员对相关规则变更或实施细则有异议，应立即停止使用本平台的相关服务或产品。相关规则及实施细则发布后会员仍继续使用本平台相关服务的，则视为接受药聚多平台的规则与实施细则。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">二 卖方入驻规则</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三条：本规则规定卖方入驻企业只有取得药聚多平台会员资格，才能从事相关交易活动。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第四条：申请会员资格须为具有合法资质的医药、食品和医疗器械生产和经营企业以及医疗机构、零售药店等。会员需网上上传电子资质并将相关纸质材料提交平台审核。会员注册时请提供真实、有效的信息，若因提供虚假的注册信息造成的支付、退款等问题，本平台不承担责任。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">第五条：平台服务内容</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）提供交易信息发布服务，对网站的商品交易进行撮合，帮助卖方拓展市场渠道提高经营效率，帮助买家采购所需商品；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）提供在线交易、在线结算服务，平台记录在线交易全程，保证交易可追溯；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）企业和产品品牌的推广服务；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（四）平台提供的其他服务。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">三 信息发布规则</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b>
              <span style="font-size: 16px">
                <br />
              </span>
            </b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第六条：交易信息发布要求</span
            >
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >卖方会员在药聚多平台发布的交易信息应当真实、完整，发布的产品价格合理，不得对购买者进行误导。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第七条：禁止发布的商品信息</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）麻醉药品、精神药品、医疗用毒性药品、放射性药品、戒毒药品和医疗机构制剂；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）国家保护并禁止销售的动、植物及其制品；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）经权威质检部门或生产商认定、公布或召回的问题商品，国家明令淘汰或停止销售的商品，商品本身或外包装上所注明的产品标准、认证标志、成份及含量不符合国家规定的商品，过期、失效、有质量问题的商品；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（四）带有宗教、种族歧视的相关商品或信息；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（五）超会员企业经营范围的信息和商品；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（六）其他法律法规禁止发布的商品信息。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第八条：其它信息发布规则</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）及时更新企业资质信息，保证资质有效；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）会员针对每笔交易的评价要客观、真实；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）禁止在药聚多平台上发布其它网站购物链接、联系方式、实体店信息、银行账号及个人第三方货款监管的银行账户；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（四）禁止在药聚多平台上散布和传播违反国家法律法规的信息。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第九条：对于违反本章规定的，药聚多平台将对相应的信息予以屏蔽、删除。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">四 交易规则</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十条：卖方会员应及时更新在线供应商品的库存信息，并保证供应商品的质量。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十一条：卖方会员须如期履行订单，按约定的时间、地点、方式配送并交货。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十二条：卖家应及时处理订单，在规定时间内发货，并在系统中填写物流信息，修改订单状态。如有特殊原因，需电话告知买家，在买家同意后，可以顺延发货。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十三条：卖家发货后，应及时在系统内录入物流信息，否则将视为未发货，因此造成的全部责任由卖方会员自行承担。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<br />
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<strong></strong
            ><span style="font-size: 14px"
              >第十四条：卖方会员在发货后，买方会员需要在线“确认收货”操作，买方会员未执行“确认收货”时，系统将在确认发货之后</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px"
              >天，视为买方已实际收货，系统将自动“确认收货”。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >若在约定期限内，买方会员未收到货，应联系平台进行续期操作，续期期限为</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px"
              >天。若还未收到货物，需要在约定期限到期后的</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px"
              >天内，向平台申诉，逾期平台不再受理，因此造成的全部责任由买方会员自行承担。买方会员验货时，对货物包装质量存在异议，可以拒绝收货。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十五条：卖方会员应保证其销售的商品在有效期内的质量，并承担法定机构认定的商品质量责任。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十六条：买方会员须如期履行电子订单，按照约定支付货款。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">五 争议处理规则</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十七条：本规则仅适用于交易双方均使用药聚多平台在线交易的用户。因未使用本交易平台或超出确认时限而产生纠纷的，药聚多平台不予处理。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十八条：会员交易双方出现纠纷后，药聚多平台有权要求交易方提供身份证明，拒不提供身份证明的交易一方提交的证据将不予认可。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第十九条：交易纠纷处理规则</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >若买家会员收货遇到问题，卖家会员应积极配合买家找到问题症结，并提供相应证据，协助解决。若确实为卖家会员原因，卖家应按照买家要求退换货。双发无法达成共识的，药聚多平台协助协调！</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >买卖双方争议无法协议解决时，可依法通过法律途径维护自身的合法权益，平台认同法院生效判决、裁定或生效仲裁结果。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十条
              为维护药聚多平台正常运营秩序，药聚多平台按照本规则指定的情形，对违反规则的会员分别进行警告、通报、停止平台服务关停账号等相应处理措施。但不免除会员应该承担的法律责任。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十一条
              药聚多平台根据卖方的投诉纠纷率等，对低于药聚多平台指定标准的卖方会员限制参加交易活动。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十二条
              卖方会员所发布的商品信息应真实合理，且应与商品本身相符。药聚多平台对出现下列任一情形的卖方会员给予商品屏蔽处理：</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）所发布商品价格与市场价格严重不符的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）刻意规避药聚多平台对商品设置规则的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）商品名称、规格、件装量、图片、价格等商品要素之间明显不匹配的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（四）使用本系统平台时，未按照核定的用途、违反国家法律法规以及本规则的规定，用于其他目的，或以转租、转让、转售等任何方式提供给第三方使用。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（五）未按时足额缴纳约定的费用。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十三条
              会员违规行为，是指违反药聚多平台交易规则，涉嫌损害药聚多平台及其它会员的正当权益，或涉嫌违反国家法律法规的行为。药聚多平台有权做出纠正、强行终止其行为和采取相应处罚的措施。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十四条
              严重违规行为，是指严重破坏药聚多平台经营秩序，并涉嫌违反国家法律法规的行为。会员严重违规视情节轻重处以警告、商品下线直至查封账户的处罚。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十五条
              被执行处罚的会员，当其全部违规行为被纠正、通过药聚多平台审核后，方可恢复正常状态。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十六条
              扰乱市场秩序，是指通过不正当方式，刻意规避药聚多平台规则或市场管控措施的行为。扰乱市场秩序的，药聚多平台给予严重违规行为处罚。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十七条
              违背承诺，是指卖方会员未按照承诺向买方会员提供以下服务，妨害买方会员权益的行为，药聚多平台视情节给予严重违规行为处罚。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）药聚多平台判定卖方会员确实应该承担退货、退款等保障责任，但卖方会员拒绝承担的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）药聚多平台卖方会员拒绝按照承诺的方式提供发票的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）药聚多平台卖方会员与买方会员在药聚多平台外进行交易的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（四）药聚多平台卖方会员，未按照网站要求提供服务的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十八条
              货物的验收：货物交付时，买方会员的收货人要按照规定查验货物，打开包装查看的货物，验货人应当要求承运人当场监督并打开包装查看，如果买方会员签署送货单将视为接受货物，买方会员需在签收货物后</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px">天内完成</span
            ><span style="font-size: 14px">“</span
            ><span style="font-size: 14px">收货确认</span
            ><span style="font-size: 14px">”</span
            ><span style="font-size: 14px">操作。</span><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第二十九条 退换货处理：买方会员须在进行查验商品后的</span
            ><span style="font-size: 14px">7</span
            ><span style="font-size: 14px"
              >日内向平台提交退货协调申请；如逾期未提交申请，平台将默认为验货合格，本笔交易成功完成。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >符合下列情况的，给予协调办理退换货</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）商品本身存在质量问题的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<a name="_Hlk5977748"></a
            ><span style="font-size: 14px"
              >（二）由于卖方原因造成发货错误或因延误发货的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（三）国家禁止、限制、暂停销售或责令召回的产品；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">（四）生产厂家有</span
            ><span style="font-size: 14px">"</span
            ><span style="font-size: 14px">产品召回</span
            ><span style="font-size: 14px">"</span
            ><span style="font-size: 14px">的；</span><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >存在下列情况的，不予协调办理退换货</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）由买方对商品使用不当、保存不当等原因而提出退货申请的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）所需退货商品的批号、型号与卖方会员在电子订单中填写的发货信息不符的；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">补充说明</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（一）药聚多平台只提供交易平台以达成买卖双方的交易，并不参与交易本身。如发生任何交易纠纷，应由双方自行协商。药聚多平台不接受买家或者卖家邮寄物品到药聚多平台；</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >（二）经买卖双方协商一致，可由双方按协商结果处理交易纠纷。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十条：双方就退换货纠纷经药聚多平台协调，仍未达成一致意见的，会员可依法通过法律途径维护自身的合法权益，药聚多平台将提供本笔交易的在线证据支持。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十一条：会员的违规行为，通过药聚多平台会员、权利人的投诉或药聚多平台排查发现与认定。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十二条：对违背承诺的违规行为，被投诉人须在被投诉之日起三天内提交证据。逾期未提交证据的，药聚多平台有权根据当时所掌握的情况进行判断与处理。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十三条：在无其它遗留问题的情况下，当卖方会员终止会员资格时，药聚多平台退还剩余保证金。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十四条：卖方会员自行做出的承诺或说明与本规则及《药聚多平台服务协议》相悖的，药聚多平台不予采信。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">六 保证金使用规则</span
              ><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十五条：卖方会员保证金被用于赔付后，平台将限制其在平台上的一切活动，直至补足保证金。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十六条：卖方会员停止与平台合作后，按照卖方入驻合同约定全额退还保证<span
                style="font-size: 14px"
                >金</span
              ></span
            ><span style="font-size: 14px">。</span><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px">
              <br />
            </span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24.1pt"
          >
            &emsp;&emsp;<b
              ><span style="font-size: 16px">七 反欺诈措施</span><span></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十七条：提交虚假证明材料</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >会员向药聚多平台提交虚假证明材料（如虚假的企业营业执照复印件、</span
            ><span style="font-size: 14px">GMP</span
            ><span style="font-size: 14px">或</span
            ><span style="font-size: 14px">GSP</span
            ><span style="font-size: 14px"
              >等相关资质认证复印件、相关负责人的身份证复印件等证件），经药聚多平台核实后，将对会员的交易账号冻结处理。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十八条：卖家填写虚假的发货信息</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >卖方发货时，应当正确填写发货信息。如卖方填写错误或虚假的发货信息，将视情节严重的，对卖方会员的交易账号进行冻结。</span
            ><span></span>
          </p>
          <p
            class="MsoNormal"
            align="left"
            style="text-align: left; text-indent: 24pt"
          >
            &emsp;&emsp;<span style="font-size: 14px"
              >第三十九条：交易过程中买卖双方，其中一方投诉另一方违反交易活动，或者创建虚假交易进行信用炒作情节严重的，经过药聚多平台核实后将对会员的交易账户进行冻结处理，情节严重有欺诈行为的涉嫌犯罪的，移交公安机关处理。</span
            ><span></span>
          </p>
          <p>&emsp;&emsp;<br /></p>
          <p>&emsp;&emsp;<br /></p>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Business'
}
</script>
